<form>
    <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="bx bx-question-mark me-1 font-20 text-primary"></i>
            Course Question 
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
</form>
<div class="course-details-container p-4">
    <div class="row">
        <div class="col-md-4 mb-3">
            <div class="course-card bg-white p-3 rounded shadow-sm h-100">
                <div class="d-flex flex-column">
                    <span class="text-muted mb-2">Course Name</span>
                    <span class="fw-medium text-capitalize">{{ course.name || 'N/A' }}</span>
                </div>
            </div>
        </div>
        <div class="col-md-4 mb-3">
            <div class="course-card bg-white p-3 rounded shadow-sm h-100">
                <div class="d-flex flex-column">
                    <span class="text-muted mb-2">Course Code</span>
                    <span class="fw-medium">{{ course.code || 'N/A' }}</span>
                </div>
            </div>
        </div>
        <div class="col-md-4 mb-3">
            <div class="course-card bg-white p-3 rounded shadow-sm h-100">
                <div class="d-flex flex-column">
                    <span class="text-muted mb-2">Duration (In days)</span>
                    <span class="fw-medium">{{ course.duration || 'N/A' }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<form [formGroup]="questionForm">
    <div class="card shadow-sm">
        <div formArrayName="courseQuestions">
            <div class="container" *ngFor="let question of courseQuestions.controls; let i = index" [formGroupName]="i">
                <div class="badge rounded-pill bg-light text-primary border px-3 py-2 fs-6">
                    Question {{ i + 1 }}
                </div>
                <div class="card-body" formGroupName="courseQuestion">
                    <div class="row g-3 mb-2">
                        <div class="col-md-3">
                            <label for="questionCategory" class="form-label">Category <b
                                    class="text-secondary">*</b></label>
                            <div class="input-group">
                                <span class="input-group-text bg-transparent border-end-0"><i
                                        class='bx bxs-layer'></i></span>
                                        <ng-select class="form-control rcx-ng-select" formControlName="questionCategoryId"
                                        [clearable]="false" placeholder="Select Category" ngbAutofocus
                                        [ngClass]="{'is-invalid': submitted[i] && question.get('courseQuestion.questionCategoryId')?.errors}">
                                        <ng-option *ngFor="let questionCategory of questionCategories"
                                            [value]="questionCategory.id">
                                            {{ questionCategory.name }}
                                        </ng-option>
                                        <ng-template ng-label-tmp let-item="item">
                                            {{ getCategoryName(item) }}
                                        </ng-template>
                                    </ng-select>
                                <div class="invalid-feedback"
                                    *ngIf="submitted[i]&& question.get('courseQuestion.questionCategoryId')?.errors">
                                    <span
                                        *ngIf="question.get('courseQuestion.questionCategoryId')?.errors?.required">Please
                                        select a category</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="questionType" class="form-label">Question Type <b
                                    class="text-secondary">*</b></label>
                            <div class="input-group">
                                <span class="input-group-text bg-transparent border-end-0"><i
                                        class='bx bxs-layer'></i></span>
                                <ng-select class="form-control rcx-ng-select" formControlName="questionType"
                                    [clearable]="false" placeholder="Select question Type"
                                    (change)="onQuestionTypeChange($event, i)"
                                    [ngClass]="{'is-invalid': submitted[i] && question.get('courseQuestion.questionType')?.errors}">
                                    <ng-option *ngFor="let type of types;" [value]="type">{{type}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback"
                                    *ngIf="submitted[i] && question.get('courseQuestion.questionType')?.errors">
                                    <span *ngIf="question.get('courseQuestion.questionType')?.errors?.required">Please
                                        select a question Type.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="question" class="form-label">Question <b class="text-secondary">*</b></label>
                            <div class="input-group">
                                <span class="input-group-text bg-transparent border-end-0">
                                    <i class='bx bx-question-mark'></i>
                                </span>
                                <textarea class="form-control" id="question" cols="1" rows="1"
                                    formControlName="question"
                                    [ngClass]="{'is-invalid': submitted[i] && question.get('courseQuestion.question')?.errors}"
                                    placeholder="Enter question"></textarea>
                                <div class="invalid-feedback"
                                    *ngIf="submitted[i] && question.get('courseQuestion.question')?.errors">
                                    <span *ngIf="question.get('courseQuestion.question')?.errors?.required">Question is
                                        required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="notes" class="form-label">Notes</label>
                            <div class="input-group">
                                <span class="input-group-text bg-transparent border-end-0">
                                    <i class='bx bx-note'></i>
                                </span>
                                <textarea class="form-control" id="notes" cols="1" rows="1" formControlName="notes"
                                    [ngClass]="{'is-invalid': submitted[i] && question.get('courseQuestion.notes')?.errors}"
                                    placeholder="Enter notes"></textarea>
                                <div class="invalid-feedback"
                                    *ngIf="submitted[i] && question.get('courseQuestion.notes')?.errors">
                                    <span *ngIf="question.get('courseQuestion.notes')?.errors?.required">Notes are
                                        required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-auto">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="mandatory"
                                    formControlName="mandatory">
                                <input class="form-check-input" type="checkbox" id="mandatory"
                                    formControlName="mandatory">
                                <label class="form-check-label" for="mandatory">Mandatory</label>
                            </div>
                        </div>
                        <div class="col-md-auto">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="active" formControlName="active">
                                <label class="form-check-label" for="active">Active</label>
                            </div>
                        </div>
                        <div class="col-md-auto">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="disabled"
                                    formControlName="disabled">
                                <input class="form-check-input" type="checkbox" id="disabled"
                                    formControlName="disabled">
                                <label class="form-check-label" for="disabled">Disabled</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div formArrayName="courseQuestionChoices">
                    <div class="card-body input-filed"
                        *ngFor="let choice of question.get('courseQuestionChoices').controls; let j = index"
                        [formGroupName]="j">
                        <div class="row align-items-center">
                            <div class="col-md-6">
                                <label for="choice" class="form-label">Choice<b class="text-secondary">*</b></label>
                                <div class="input-group">
                                    <span class="input-group-text bg-transparent border-end-0">
                                        <i class='bx bx-list-check'></i>
                                    </span>
                                    <!-- <span class="input-group-text bg-transparent border-end-0">
                                        {{ getChoiceLabel(j) }}) 
                                    </span> -->
                                    <input type="text" class="form-control" formControlName="choice"
                                        [ngClass]="{'is-invalid': choice.get('choice')?.invalid && (submitted[i] || choice.get('choice')?.touched)}"
                                        placeholder="Enter Choice" />

                                    <div class="invalid-feedback"
                                        *ngIf="choice.get('choice')?.invalid && (submitted[i] || choice.get('choice')?.touched)">
                                        <span>Choice is required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1 text-center mt-2">
                                <label class="form-label d-block">&nbsp;</label>
                                <div class="radio-container" (click)="toggleSelection(i, j)">
                                    <i class="bx" [ngClass]="{
                      'bx-check-circle text-success': isSelected(i, j),
                      'bx-circle text-dark': !isSelected(i, j)
                    }"></i>
                                </div>
                            </div>
                            <div class="col-md-2" *ngIf="isSelected(i, j)">
                                <label class="form-label">Mark</label>
                                <div class="input-group">
                                    <span class="input-group-text bg-transparent border-end-0">
                                        <i class='bx bx-edit-alt'></i>
                                    </span>
                                    <input type="number" class="form-control" formControlName="point"
                                        placeholder="Enter Mark" />
                                </div>
                            </div>
                            <div class="col-md-3 text-center btn-choice mt-4 ">
                                <div class="d-flex justify-content-center align-items-center mt-2">
                                    <button type="button" class="btn btn-danger btn-sm me-2"
                                        (click)="removeChoice(i, j)"
                                        *ngIf="question.get('courseQuestionChoices').length > 1 || question.get('courseQuestionChoices').at(j).get('id')?.value">
                                        <i class="bx bx-trash" title="Delete Choice"></i>
                                    </button>
                                    <button type="submit" (click)="addChoice(i)"
                                        [disabled]="question.get('courseQuestionChoices').length >= maxChoices"
                                        class="btn btn-secondary btn-sm me-2">
                                        <i class="bx bx-plus btn-icon" title="Add Choice"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end mb-3">
                    <button type="button" class="btn btn-danger" (click)="deleteQuestion(i)"
                    *ngIf="courseQuestions.at(i).get('courseQuestion.id')?.value">
                    <i class="bx bx-trash"></i> Delete
                </button>
                    <button type="submit" class="btn btn-secondary me-2" (click)="saveQuestion(inProgress, i)"
                        #inProgress [ngClass]="{'no-event': inProgress?.value == 'true'}">
                        <ng-container *ngIf="inProgress?.value == 'true'">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ courseQuestions.at(i).get('courseQuestion.id')?.value ? 'Updating...' : 'Saving...' }}
                        </ng-container>
                        <ng-container *ngIf="inProgress?.value != 'true'">
                            <i class="bx bx-save"></i>
                            {{ courseQuestions.at(i).get('courseQuestion.id')?.value ? 'Update' : 'Save' }}
                        </ng-container>
                    </button>
                </div>
                <hr  *ngIf="courseQuestions.at(i).get('courseQuestion.id')?.value">
            </div>
        </div>
    </div>
</form>